import { useForm as useFormHook } from "hooks";
import { BooleanSwitchValue, MOR } from "consts/general";
import type { IbanXsBanksRecipientsPivot } from "features/openBanking/types";
import {
    FormField,
    type IbanXSBanksRecipientsPivotForm,
    type IbanXSBanksRecipientsPivot
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    iso2 = '',
    ...restInitialValues
}: Partial<IbanXsBanksRecipientsPivot> = {}): IbanXSBanksRecipientsPivot => ({
    [FormField.IsEnabled]: BooleanSwitchValue.Off,
    [FormField.BankId]: BooleanSwitchValue.Off,
    [FormField.RecipientId]: BooleanSwitchValue.Off,
    [FormField.Mor]: MOR.Default,
    [FormField.Iso2]: Array.of(iso2),
    ...restInitialValues
});

export const useForm = (ibanXSBanksRecipientsPivotForm: IbanXSBanksRecipientsPivotForm) =>
    useFormHook({
        enableReinitialize: true,
        ...ibanXSBanksRecipientsPivotForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
